module.exports = __webpack_public_path__ + "img/Winning Form - Copy-01.5718df96.svg";